import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import BucketFilled from '../../Assetes/Images/kfc-basket.png'
import { priceunit } from '../../Components/client-config';
import { useTranslation } from 'react-i18next';
import { DiscountDisplay } from '../../Components/DiscountDisplay';


export default function OrderHistoryDetail(props?:any) {
  const { order_item,order_grossprice,pos_service_fee,delivery_fee } = props.orderData;
  const { t } = useTranslation();

  
  return (
    <div>
       <div className="w-100">
            <div className="history-slip-box">
             
              <div className='instructions-box '>
                <div className='bucket-img'>
                  <img src={BucketFilled} alt="" />
              <h5>{t("YOUR_ORDER")}</h5>
                </div>
            { order_item?.map((item:any,id:any)=>
              <div className='price-info' key={id}>
                <h6>{item?.item_name || item?.combo_name}: { item?.order_item_quantity}</h6>
                <h5>{priceunit} { item?.order_item_grossprice}</h5>
              </div>
            )}
          
            <div className='border-top'></div>
            {pos_service_fee>0 && 
              <div className='price-info border-top pt-2'>
                  <h6>{t("POS_FEE")} </h6>
                  <h5>{priceunit} {pos_service_fee}</h5>
              </div>
            }
            {delivery_fee>0 &&
              <div className='price-info pt-2'>
                  <h6>{t("DELIVERY_FEE")} :</h6>
                  <h5>{priceunit} {delivery_fee}</h5>
              </div>
            }
            {props.orderData?.tax_amount > 0 && 
              <div className='price-info pt-2'>
                <h6>{t("GST")} {props.orderData?.tax_percent ? `( ${Math.round(props.orderData.tax_percent)} % )` : ''}: </h6>
                <h5>{priceunit} {Math.round(props.orderData?.tax_amount)}</h5>
              </div>
            }
            <DiscountDisplay
              amount={props.orderData?.discount || 0}
              label="DISCOUNT"
              className="price-info pt-2"
            />
            <DiscountDisplay
              amount={props.orderData?.coupon_discount_value || 0}
              label="VOUCHER"
              couponCode={props.orderData?.coupon_code || props.orderData?.orders_coupon_code}
              className="price-info pt-2"
            />
              <div className='price-info pt-2'>
                  <h6>{t("TOTAL")} </h6>
                  <h5>{priceunit} { order_grossprice}</h5>
              </div>
              </div>
              
            </div>
            <div className='slip-box'>

            </div>
          </div>
    </div>
  )
}
